const DEFAULTS = {
  config: { linkTypes: { anchor: true } }
};
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
